import { ReactNode } from "react"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { AdminSidebar } from "@/components/admin-ui/admin-sidebar"
import EnvironmentBanner from "./EnvironmentBanner"
import { useTheme } from "@/hooks/useTheme"
import { Moon, Sun } from "lucide-react"
import { Button } from "@/components/ui/button"

interface MainLayoutProps {
  children: ReactNode
}

export default function MainLayout({ children }: MainLayoutProps) {
  const { theme, toggleTheme } = useTheme()

  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset>
        <EnvironmentBanner />
        {/* Mobile-only top bar: sidebar trigger（dark mode toggle 已隱藏） */}
        <div className="flex h-10 items-center gap-2 px-4 md:hidden">
          <SidebarTrigger className="-ml-1" />
          <div className="flex-1" />
          {false && (
            <Button
              variant="ghost"
              size="icon"
              className="h-7 w-7"
              onClick={toggleTheme}
              aria-label={theme === "light" ? "切換到深色模式" : "切換到淺色模式"}
            >
              {theme === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
            </Button>
          )}
        </div>
        <div className="flex-1 overflow-y-auto p-6">
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
